var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[(_vm.title)?_c('div',{staticClass:"card-header"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card-body"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }